<template>
  <div class="navbar navbar--footer">
    <div class="content-footer">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="navbar-nav-link" @click.prevent="openRequisitesModal">
            {{ $t('footer.requisites') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="navbar-nav-link" download href="https://saskaita123.lt/privatumo-politika" target="_blank">
            {{ $t('footer.policy') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="navbar-nav-link" download href="https://saskaita123.lt/naudojimosi-salygos" target="_blank">
            {{ $t('footer.use_terms') }}
          </a>
        </li>
        <li class="nav-item">
          <a @click.prevent="openPaymentModal" class="navbar-nav-link" href="#">
            {{ $t('footer.plans') }}
          </a>
        </li>
      </ul>

      <div>
        <span class="copyright">{{ $t('footer.all_rights_reserved', { year: new Date().getFullYear() }) }}</span>
      </div>
    </div>
    <requisites-info-modal v-if="requisitesModalVisible" v-model="requisitesModalVisible"/>
  </div>
</template>

<script setup>
  import { defineAsyncComponent, ref } from 'vue';
  import { useSubscriptionStore } from '@/stores/subscription';

  const RequisitesInfoModal = defineAsyncComponent(() => import('@/modals/info/requisites/manage.vue'));

  const requisitesModalVisible = ref(false);
  const subscriptionStore = useSubscriptionStore();

  function openRequisitesModal() {
    requisitesModalVisible.value = true;
  }

  function openPaymentModal() {
    subscriptionStore.setModalVisible(true);
  }
</script>
